import React from 'react';
import {
  IonBadge,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonItem,
  IonIcon,
  IonLabel,
  IonList,
  IonText,
} from '@ionic/react';
import { heart, chatbox } from 'ionicons/icons';
import { formatDistanceToNow } from 'date-fns';

const PostCard = ({ post }) => {
  return (
    <div>
      <IonCard button routerLink={`/post/${post && post._id}`}>
        <IonCardContent class='ion-no-padding'>
          <IonList lines='none'>
            <IonItem>
              <IonLabel>
                <IonCardHeader class='ion-no-padding ion-text-wrap' style={{ padding: '6px' }}>
                  <IonCardTitle>
                    <h1>{post && post.title}</h1>
                  </IonCardTitle>
                  <IonBadge style={{ marginRight: '5px' }} color='secondary'>
                    {post && post.topic}
                  </IonBadge>
                  {post &&
                    post.tags.map((tag) => <IonBadge style={{ marginRight: '5px' }}>{tag.slice(0, 25)}</IonBadge>)}
                </IonCardHeader>
                <IonCardContent className='ion-text-wrap ion-no-padding' style={{ padding: '8px' }}>
                  <p>{post && (post.desc.length < 350 ? post.desc : post.desc.slice(0, 350) + '...')}</p>
                </IonCardContent>
                <p
                  style={{
                    alignItems: 'center',
                    fontSize: '1.2 rem',
                    padding: '2px 20px 6px 6px',
                  }}
                >
                  <IonIcon
                    icon={heart}
                    style={{
                      verticalAlign: 'middle',
                    }}
                    color='danger'
                  />{' '}
                  <IonText
                    style={{
                      verticalAlign: 'middle',
                      marginRight: '8px',
                    }}
                    color='danger'
                  >
                    {post && post.noOflikes}
                  </IonText>
                  <IonIcon
                    icon={chatbox}
                    style={{
                      verticalAlign: 'middle',
                    }}
                    color='dark'
                  />{' '}
                  <IonText
                    style={{
                      verticalAlign: 'middle',
                    }}
                    color='dark'
                  >
                    {post && post.comments.length}
                  </IonText>
                  <div className='ion-float-end'>
                    <IonText
                      style={{
                        verticalAlign: 'middle',
                      }}
                    >
                      <em>
                        posted by <strong>{post && post.authorName}</strong>{' '}
                        {post && formatDistanceToNow(new Date(post.postedWhen))} ago
                      </em>
                    </IonText>
                  </div>
                </p>
              </IonLabel>
            </IonItem>
          </IonList>
        </IonCardContent>
      </IonCard>
    </div>
  );
};

export default PostCard;
